import PropTypes from 'prop-types';
import React from 'react';
import CollapseSelect from 'components/CollapseSelect';
import {injectIntl} from 'react-intl';
import {GRAIN_OPTIONS} from './ChartDateGrainConstants';
import './ChartDateGrain.css';

class ChartDateGrain extends React.Component {
  handleGrainChange(e) {
    this.props.onGrainChange(e.target.value);
  }

  render() {
    const options = GRAIN_OPTIONS.map(grain => {
      return (
        <option key={grain.key} value={grain.key}>
          {this.props.intl.formatMessage(grain.label)}
        </option>
      );
    });
    return (
      <CollapseSelect
        className="ChartDateGrain"
        onChange={this.handleGrainChange.bind(this)}
        value={this.props.grain}
      >
        {options}
      </CollapseSelect>
    );
  }
}

ChartDateGrain.propTypes = {
  grain: PropTypes.string.isRequired,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(ChartDateGrain);
